export const clamp = (x: number, min: number, max: number): number => {
  return max >= min ? Math.min(Math.max(x, min), max) : clamp(x, max, min);
};

export const sum = (xs: number[]): number => {
  return xs.reduce((x, y) => x + y, 0);
};
